<template>
  <v-card class="mb-7">
    <v-card-text class="pa-5">
      <PaymentHeader :totalSum="totalSum">
        <template #filters>
          <div>
            <div class="d-flex align-center pa-3">
              <v-autocomplete
                v-model="seccionSeleccionada"
                label="Sección"
                :items="secciones"
                outlined
                dense
                style="max-width: 450px;"
                hide-details
                clearable
                item-text="nombre"
                item-value="id"
                @change="applyFilter"
              />
              <v-select
                label="Tipo de pago de matrícula"
                class="mx-10"
                :items="matriculaPaymentTypes"
                v-model="currentPaymentType"
                item-text="text"
                item-value="value"
                outlined
                dense
                style="max-width: 210px;"
                hide-details
                @change="applyFilter"
              />
              <v-switch
                class="ma-0"
                v-model="pagado"
                :label="pagado ? 'Solo pagos realizados': 'Solo pagos pendientes'"
                color="secondary"
                hide-details
                inset
                @change="applyFilter(); filters.startDate=''; filters.endDate=''"
              />
              
              <v-spacer></v-spacer>

              <v-btn
                color="secondary"
                class="mt-3 mt-sm-0"
                :loading="exporting"
                @click="exportCsv"
              >
              <v-icon left>mdi-download</v-icon>
                EXPORTAR CSV / EXCEL
              </v-btn>
            </div>

            <BaseDataRange
              v-if="pagado"
              style="max-width: 474px; margin: 0;"
              @sendStartDate="sendStartDate"
              @sendEndDate="sendEndDate"
              @clearStartDate="filters.startDate=''"
              @clearEndDate="filters.endDate=''"
            />
            <div class="d-flex align-center flex-wrap pa-3 pt-0">
              <div style="max-width: 480px; flex: 1 1 480px; min-width: 260px;">
                <v-text-field
                  v-model="searchInput"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  outlined
                  clearable
                  hide-details
                  label="Buscar (nombre, email, DNI, celular)"
                  @input="onSearchInput"
                />
              </div>


            </div>
          </div>
        </template>
      </PaymentHeader>

      <!-- Botón Exportar CSV -->


      <PaymentDataTable
        :headers="headerArray"
        :items="paymentsFiltered"
        :options.sync="options"
        :server-items-length="totalCounts"
        :items-per-page="10"
        :loading="loading"
        :next="next"
        @goBack="options.page--"
        @goAhead="options.page++"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import BaseDataRange from '@/components/commonComponents/BaseDataRange'
import PaymentHeader from '@/components/dashboardComponents/payments/PaymentHeader'
import PaymentDataTable from '@/components/dashboardComponents/payments/PaymentDataTable'
import { mapState, mapActions } from "vuex"

export default {
  components: { BaseDataRange, PaymentHeader, PaymentDataTable },
  data: () => ({
    loading: false,
    exporting: false,
    pagado: true,
    headerArray: [
      { text: 'Fecha del depósito', value: 'fecha_deposito',   sortable: true, align: 'start' },
      { text: 'Nombres',            value: 'nombre',           sortable: true, align: 'start' },
      { text: 'Apellidos',          value: 'apellido',         sortable: true, align: 'start' },
      { text: 'Correo',             value: 'email',            sortable: true, align: 'start' },
      { text: 'Celular',            value: 'celular',          sortable: true, align: 'start' },
      { text: 'Documento',          value: 'documento',        sortable: true, align: 'start' },
      { text: 'Sección',            value: 'seccion',          sortable: true, align: 'start' },
      { text: 'Monto del pago',     value: 'monto',            sortable: true, align: 'start' },
      { text: 'Tipo de pago de matricula', value: 'pago_cuotas', sortable: true, align: 'start' },
    ],
    paymentsFiltered: [],
    filters: {
      startDate: '',
      endDate: '',
      section: null,
      page: 1,
      search: '',                        // <-- USAREMOS ESTE PARA ?search=
      state: 'PAGADO'
    },
    options: { page: 1, sortBy: [], sortDesc: [] },
    previous: null,
    next: null,
    totalCounts: 0,
    startDate: '',
    endDate: '',
    totalSum: '',
    applyingFilter: false,
    seccionSeleccionada: null,
    matriculaPaymentTypes: [
      { text: 'Todos',      value: 'Todos' },
      { text: 'En cuotas',  value: 'En cuotas' },
      { text: 'Al contado', value: 'Al contado' }
    ],
    currentPaymentType: 'Todos',

    // ---- NUEVO:
    searchInput: '',                     // campo visual del <v-text-field>
    _searchTimer: null,                  // timer de debounce
  }),
  computed: {
    ...mapState(['searchGlobal', 'secciones']),
    // mapping UI -> backend ordering param
    orderingParam () {
      const map = {
        fecha_deposito: 'fecha_deposito',
        nombre:        'nombre',
        apellido:      'apellido',
        email:         'email',
        celular:       'celular',
        documento:     'documento',
        seccion:       'seccion',
        monto:         'monto',
        pago_cuotas:   'pago_cuotas',
      }
      const sb = this.options.sortBy?.[0]
      if (!sb) return ''
      const backend = map[sb]
      if (!backend) return ''
      const desc = !!(this.options.sortDesc && this.options.sortDesc[0])
      return `${desc ? '-' : ''}${backend}`
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        // ⬇️ usamos filters.search (NO searchGlobal)
        this.$router
          .push(`/dashboard/payments/?fecha_inicio=${this.filters.startDate || ''}` +
                `&fecha_fin=${this.filters.endDate || ''}` +
                `&seccion=${this.filters.section || ''}` +
                `&page=${this.filters.page || 1}` +
                `&search=${this.filters.search || ''}` +        // <-- CAMBIO
                `&estado=${this.filters.state || ''}` +
                `&tipo_pago=${this.currentPaymentType || ''}` +
                `&ordering=${this.orderingParam}`)
          .catch(()=>{})
      }
    },
    $route () {
      this.setQueryParamsLocally()
      this.getDataFromApiFetchData()
    },
    options: {
      deep: true,
      handler () {
        if (!this.applyingFilter) {
          this.filters.page = this.options.page || 1
          const q = new URLSearchParams(this.$route.query)
          q.set('page', String(this.filters.page || 1))
          q.set('ordering', this.orderingParam || '')
          this.$router.push({ path: this.$route.path, query: Object.fromEntries(q.entries()) }).catch(()=>{})
        }
      }
    },
    // Si aún quieres que el buscador global sincronice aquí:
    searchGlobal (val) {                 // <-- OPCIONAL, mantenemos compatibilidad
      // solo si no estás escribiendo algo distinto localmente
      if (!this.searchInput) {
        this.searchInput = val || ''
        this.filters.search = this.searchInput
      }
    }
  },
  methods: {
    ...mapActions(['fetchSecciones']),
    horaDeposito (item) {
      const d = new Date(item); return d.toString().split(" ")[4]
    },
    // 🔎 debounce del buscador local
    onSearchInput () {                   // <-- NUEVO
      clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => {
        this.filters.page = 1
        this.filters.search = (this.searchInput || '').trim()
      }, 400)
    },
    sendStartDate (item) {
      this.filters.page = 1
      if (this.$route.query.seccion) this.filters.section = this.$route.query.seccion
      this.filters.startDate = item
    },
    sendEndDate (item) {
      this.filters.page = 1
      if (this.$route.query.seccion) this.filters.section = this.$route.query.seccion
      this.filters.endDate = item
    },
    async applyFilter () {
      this.applyingFilter = true
      this.filters.section = this.seccionSeleccionada || ''
      this.filters.state   = this.pagado ? 'PAGADO' : 'PENDIENTE'
      this.options.page = 1
      await this.$router.push(
        `/dashboard/payments/?fecha_inicio=${this.filters.startDate || ''}` +
        `&fecha_fin=${this.filters.endDate || ''}` +
        `&seccion=${this.filters.section || ''}` +
        `&page=${this.options.page || 1}` +
        `&search=${this.filters.search || ''}` +                 // <-- CAMBIO
        `&estado=${this.filters.state || ''}` +
        `&tipo_pago=${this.currentPaymentType || ''}` +
        `&ordering=${this.orderingParam || ''}`
      ).catch(()=>{})
      this.applyingFilter = false
    },
    async fetchPayments (id) {
      const response = await axios.get(`api/admin/matriculas/pagos/?page=${id}&page_size=10`)
      this.totalSum = response.data.total
      return response.data
    },
    async getDataFromApiFetchData () {
      this.loading = true
      const response = await this.fetchDataTable()
      this.paymentsFiltered = response.items
      this.loading = false
    },
    async fetchDataTable () {
      const payment = await this.fetchData()
      const items = payment.results
      this.next = payment.next
      this.totalCounts = payment.count
      return { items, total: items.length }
    },
    async fetchData () {
      try {
        // ⬇️ tomamos 'search' directo de la URL (que viene de filters.search)
        const { data } = await axios.get(
          `api/admin/matriculas/pagos/?` +
          `fecha_inicio=${this.$route.query.fecha_inicio || ''}` +
          `&fecha_fin=${this.$route.query.fecha_fin || ''}` +
          `&seccion=${this.$route.query.seccion || ''}` +
          `&page=${this.$route.query.page || 1}` +
          `&search=${this.$route.query.search || ''}` +           // <-- CAMBIO
          `&estado=${this.$route.query.estado || this.filters.state || ''}` +
          `&page_size=10` +
          `&tipo_pago=${this.$route.query.tipo_pago || ''}` +
          `&ordering=${this.$route.query.ordering || ''}`
        )
        this.totalCounts = data.count
        this.next = data.next
        this.previous = data.previous
        this.totalSum = data.total
        return data
      } catch (e) {
        this.$root.$confirm({ title: 'Ups', message: e, acceptText: 'Ok' })
      }
    },
    setQueryParamsLocally () {
      this.startDate = this.$route.query.fecha_inicio || ''
      this.endDate   = this.$route.query.fecha_fin || ''
      this.seccionSeleccionada = this.$route.query.seccion ? Number(this.$route.query.seccion) : null
      this.options.page = Number(this.$route.query.page || 1)
      this.pagado = (this.$route.query.estado !== 'PENDIENTE')
      this.currentPaymentType = this.$route.query.tipo_pago || 'Todos'

      // 🔁 inicializar el buscador visible y el filtro de búsqueda
      this.searchInput = this.$route.query.search || ''          // <-- NUEVO
      this.filters.search = this.searchInput                     // <-- NUEVO

      const ord = (this.$route.query.ordering || '').trim()
      if (ord) {
        const desc = ord.startsWith('-')
        const base = desc ? ord.slice(1) : ord
        const inverseMap = {
          fecha_deposito: 'fecha_deposito',
          nombre: 'nombre',
          apellido: 'apellido',
          email: 'email',
          celular: 'celular',
          documento: 'documento',
          seccion: 'seccion',
          monto: 'monto',
          pago_cuotas: 'pago_cuotas',
        }
        const ui = inverseMap[base]
        this.options.sortBy   = ui ? [ui] : []
        this.options.sortDesc = ui ? [desc] : []
      } else {
        this.options.sortBy = []
        this.options.sortDesc = []
      }
    },
    async exportCsv () {
      try {
        this.exporting = true
        const params = new URLSearchParams({
          fecha_inicio: this.filters.startDate || '',
          fecha_fin:    this.filters.endDate   || '',
          seccion:      this.filters.section   || '',
          search:       this.filters.search    || '',            // <-- CAMBIO
          estado:       this.filters.state     || '',
          tipo_pago:    this.currentPaymentType|| '',
          ordering:     this.orderingParam     || ''
        })
        const res = await axios.get(`api/admin/matriculas/pagos/export_csv/?${params.toString()}`, { responseType: 'blob' })
        const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8' })
        const url  = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'pagos.csv'
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      } finally {
        this.exporting = false
      }
    }
  },
  async created() {
    this.loading = true
    this.setQueryParamsLocally()
    this.fetchSecciones()
    await this.getDataFromApiFetchData()
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
.total { font-size: 14px; line-height: 16px; color: #B2BAC4; }
.sum   { font-weight: 900; font-size: 18px; line-height: 21px; color: #2196F3; border-bottom: 1px solid #B2BAC4; }
</style>
